import classNames from "classnames";
import React from "react";

import Img from "@components/FileServer/Img";
import FormattedMessage from "@components/UI/FormattedMessage";

interface StepRowProps {
  activeStep: number;
  stepNumber: number;
  text: React.ReactElement;
  isHotel?: boolean;
}

function StepRow({
  activeStep,
  stepNumber,
  text,
  isHotel = false,
}: StepRowProps) {
  const isActive = activeStep === stepNumber;
  const isFinished = activeStep > stepNumber;
  const isNext = !isActive && !isFinished && activeStep < stepNumber;

  return (
    <div className="step-row-mobile">
      <div
        className={classNames("search-steps-circle", {
          "step-circle-active-mobile": isActive,
          "step-circle-finished-mobile": isFinished,
          "step-circle-next-mobile": isNext,
        })}
      >
        {isFinished ? (
          <Img
            className="check-stepper-mobile"
            src="/static/images/ico-check.svg"
            alt="check icon"
          />
        ) : (
          <span>{stepNumber}</span>
        )}
      </div>
      {isActive && (
        <span className={`step-label-mobile ${isHotel ? "hotel-label" : ""}`}>
          {text}
        </span>
      )}
    </div>
  );
}

type Props = {
  page: string;
};

function SearchStepsMobile({ page }: Props) {
  const isBestOfferResults = page === "bestOfferResults";
  let activeStep = 1;

  if (isBestOfferResults || page === "result" || page === "hotel") {
    activeStep = 2;
  }
  if (page === "booked" || page === "hotelBook") {
    activeStep = 3;
  }
  if (page === "hotelBooked") {
    activeStep = 4;
  }

  const isHotel = page.includes("hotel");
  const steps = [
    {
      label: (
        <FormattedMessage
          id={
            isBestOfferResults ? "BestOffers.title" : "FlightOffer.pickflight"
          }
        />
      ),
    },
    {
      label: (
        <FormattedMessage
          id={
            isBestOfferResults
              ? "BestOffers.pickFlight"
              : "SearchSteps.yourInformation"
          }
        />
      ),
    },
    { label: <FormattedMessage id="Result.confirmBooking" /> },
  ];

  const hotelSteps = [
    steps[0],
    page.includes("hotel") && {
      label: <FormattedMessage id="SearchSteps.selectRooms" />,
    },
    ...steps.slice(1),
  ];

  const correctSteps = isHotel ? hotelSteps : steps;

  return (
    <div className="search-steps-mobile-wrapper">
      {correctSteps.map((step, index) => (
        <React.Fragment key={index}>
          <StepRow
            activeStep={activeStep}
            stepNumber={index + 1}
            text={step.label}
            isHotel={isHotel}
          />
          {index + 1 < correctSteps.length && (
            <span
              className={`step-divider-mobile ${
                isHotel ? "hotel-divider" : ""
              }`}
            >
              —
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default SearchStepsMobile;
